Vue.component("row-info", {
    props: ["label", "content", "iconClass"],
    template: '<div class="info"><span class="content"><i v-if="iconClass" :class="iconClass" :title="label"></i><span v-html="content"></span></span></div>'
});

Vue.component("row-link", {
    props: ["title", "label", "path", "desc", "descHtml", "status", "iconClass", "extraLinks"],
    template: '<div class="info"><span v-if="title" class="label">{{ title }}:</span><span class="content"> \
        <i v-if="iconClass" :class="iconClass" :title="title || label"></i><a :href="path" target="_blank" :title="title">{{ label }}</a><span v-if="status" class="project-status" :class="\'status-\' + status.toLowerCase().replace(/\\s+/g, \'-\')"> [{{status}}]</span> \
        <span class="project-description" v-if="descHtml" v-html="descHtml"></span><span class="project-description" v-else-if="desc">{{desc}}</span> \
        <span v-if="extraLinks && extraLinks.length" class="project-links"><span class="project-link-row" v-for="link in extraLinks"><i v-if="link.iconClass" :class="link.iconClass" :title="link.title || link.label"></i><a :href="link.path" target="_blank">{{ link.label }}</a></span></span> \
        </span> \
        </div>'
});

Vue.component("row-archive", {
    props: ["label", "path", "desc", "year"],
    template: '<div class="info"><span class="content"><span class="archive-year">{{ year }}</span> <a :href="path" target="_blank">{{ label }}</a><span class="archive-description" v-if="desc"> &mdash; {{desc}}</span></span></div>'
});

Vue.component("row-tagline", {
    props: ["label", "tags", "iconClass"],
    template: '<div class="info info-array"><span class="content code-array"> \
        <span class="code-array-header"><i v-if="iconClass" :class="iconClass" class="code-array-icon"></i><span class="code-array-label">{{ label }}</span><span class="code-array-brace code-array-brace-open">[</span></span> \
        <span class="code-array-item" v-for="(tag, index) in tags"><span class="code-array-value">{{tag}}</span><span v-if="index < tags.length - 1" class="code-array-comma">,</span></span> \
        <span class="code-array-brace code-array-brace-close">]</span> \
    </span></div>'
});

Vue.component("row-inline-tagline", {
    props: ["label", "tags", "iconClass"],
    template: '<div class="info"><span class="label"><i v-if="iconClass" :class="iconClass" :title="label"></i>{{ label }}</span><span class="content code-array-inline"> \
        <span class="code-array-inline-brace">[ </span><span class="code-array-inline-item" v-for="(tag, index) in tags"><span class="code-array-inline-value">{{tag}}</span><span v-if="index < tags.length - 1" class="code-array-inline-comma">, </span></span><span class="code-array-inline-brace"> ]</span> \
    </span></div>'
});

const manuals = {
    help: "Available commands: help, clear, collapse, expand, maximize, restore, projects, links, about, open [name], play.<br>Adventure commands are also accepted directly in the terminal.",
    projects: "List the public projects shown in the Projects section.",
    links: "List the public links shown in the Links section.",
    about: "Print the short site description.",
    open: "open [name] : open a project, demo, or public link by label.",
    play: "L'idolo dei tombini is currently Italian-only. Start with: guarda, inventario, nord, sud, est, ovest, prendi [oggetto], apri [oggetto], dai [oggetto] a [personaggio], parla [personaggio], save, load."
};

for (var sectionId in sections) {
    sections[sectionId].state = {
        hidden: false,
        collapsed: false,
        maximized: false
    };
}

// The console starts closed; a saved state from a previous visit overrides this.
sections.console.state.collapsed = true;

// Phones and touch devices get no console: on-screen keyboards don't send usable keydown events.
var isMobile = window.matchMedia("(max-width: 767px), (pointer: coarse)").matches;

var App = new Vue({
    el: "#app",
    data: {
        title: title,
        updated: updated,
        sections: sections,
        enableBackup: true,
        numbers: [],
        gameOn: true,
        isMobile: isMobile,
        status: {
            line: 1,
            words: 0
        },
        console: {
            area: {},
            content: "",
            prompt: " ",
            caret: "█",
            line: "",
            history: [],
            historyPos: 0,
            callbacks: {
                before: [],
                after: []
            },
            mask: false,
            colors: {
                normal: "#999999",
                error: "#BB0000",
                ok: "#00AA00",
                AI: "violet"
            },
            lastPrompt: 0
        }
    },

    mounted() {
        this.restore();

        this.console.area = document.getElementById("console-area");

        this.write("*** IrpC Terminal v2.0 ***", true, "AI");
        this.write("Type help for site commands. Adventure commands are still available.", true, "normal");
        this.newLine();

        for (var lineNumber = 1; lineNumber <= 280; ++lineNumber) {
            this.numbers.push(lineNumber);
        }

        window.addEventListener("scroll", this.updateStatusLine, { passive: true });
        this.$nextTick(this.updateStatusWords);

        if (!this.isMobile && !this.sections.console.state.collapsed) {
            this.console.area.focus();
        }
    },

    methods: {
        toggleSection: function(sectionId) {
            if (!this.sections[sectionId]) return;
            this.$set(this.sections[sectionId].state, "collapsed", !this.sections[sectionId].state.collapsed);
            this.backup();
            this.$nextTick(this.updateStatusWords);
        },

        // Status bar: the "cursor" line is the first editor line visible at the top of the window.
        updateStatusLine: function() {
            var line = document.querySelector(".editor-background-line");
            var lineHeight = line ? line.offsetHeight || 18 : 18;
            this.status.line = Math.floor(window.scrollY / lineHeight) + 1;
        },

        updateStatusWords: function() {
            var content = document.getElementById("content");
            var text = content ? content.innerText.trim() : "";
            this.status.words = text ? text.split(/\s+/).length : 0;
        },

        openSection: function(sectionId) {
            if (!this.sections[sectionId]) return;
            this.$set(this.sections[sectionId].state, "collapsed", false);
            this.backup();
            this.$nextTick(function() {
                var target = document.getElementById("section-" + sectionId);
                if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
            });
        },

        toggleConsole: function() {
            this.$set(this.sections.console.state, "collapsed", !this.sections.console.state.collapsed);
            this.backup();
            if (!this.sections.console.state.collapsed) {
                this.$nextTick(function() {
                    this.console.area.focus();
                    this.scrollToBottom();
                });
            }
        },

        maximizeConsole: function() {
            if (this.sections.console.state.collapsed) {
                this.$set(this.sections.console.state, "collapsed", false);
                this.backup();
            }
            document.body.classList.add("full-console");
            this.$nextTick(function() {
                this.console.area.focus();
                this.scrollToBottom();
            });
        },

        restoreConsole: function() {
            document.body.classList.remove("full-console");
            this.$nextTick(function() {
                this.console.area.focus();
                this.scrollToBottom();
            });
        },

        playAdventure: function() {
            this.maximizeConsole();
            this.write(manuals.play, true, "game");
            this.newLine();
        },

        backup: function() {
            if (!this.enableBackup) return false;

            var sectionStates = {};
            for (var sectionId in this.sections) {
                sectionStates[sectionId] = this.sections[sectionId].state;
            }

            var data = {
                sections: sectionStates,
                console: {
                    prompt: this.console.prompt,
                    history: this.console.history,
                    historyPos: this.console.historyPos,
                    lastPrompt: this.console.lastPrompt
                }
            };

            localStorage.setItem("data", btoa(JSON.stringify(data)));
        },

        restore: function() {
            if (!this.enableBackup || localStorage.getItem("data") === null) return false;

            var data = JSON.parse(atob(localStorage.getItem("data")));
            if (data.sections) {
                for (var sectionId in data.sections) {
                    if (this.sections[sectionId]) {
                        this.sections[sectionId].state = data.sections[sectionId];
                    }
                }
            }
            if (data.console) {
                for (var key in data.console) {
                    this.console[key] = data.console[key];
                }
            }
        },

        clearBackup: function() {
            if (!this.enableBackup) return false;
            localStorage.removeItem("data");
        },

        consoleType: function($event) {
            var key = ($event.key || $event.which || $event.data);

            switch (key) {
                case "Escape":
                    if (document.body.classList.contains("full-console")) this.restoreConsole();
                    break;
                case "Shift":
                case "Control":
                case "Alt":
                case "AltGraph":
                case "Insert":
                case "Delete":
                case "Home":
                case "PageDown":
                case "PageUp":
                case "End":
                case "ScrollLock":
                case "Pause":
                case "NumLock":
                case "ArrowLeft":
                case "ArrowRight":
                case "Meta":
                case "ContextMenu":
                case "CapsLock":
                case "Unidentified":
                case "undefined":
                case undefined:
                case "Undefined":
                case "Tab":
                case "F1":
                case "F2":
                case "F3":
                case "F4":
                case "F6":
                case "F7":
                case "F8":
                case "F9":
                case "F10":
                case "F11":
                case "F12":
                    break;

                case "F5":
                    if (confirm("Do you want to reload the window? Terminal memory will be lost.")) {
                        location.reload();
                    }
                    break;

                case "Enter":
                    this.clearCaret();
                    if (this.console.line.trim() !== "" && this.console.line !== this.console.history[this.console.historyPos - 1]) {
                        this.sendLineToHistory(this.console.line);
                    }
                    this.console.historyPos = this.console.history.length;
                    this.write("", true);
                    this.consoleCommand(this.console.line);
                    break;

                case "Backspace":
                    if (this.console.line.length > 0) {
                        this.clearCaret();
                        this.console.line = this.console.line.slice(0, -1);
                        this.console.content = this.console.content.slice(0, -1) + this.getCaret();
                    }
                    break;

                case "ArrowUp":
                    if (this.console.historyPos > 0) {
                        this.clearLine();
                        this.console.historyPos -= 1;
                        this.console.line = this.console.history[this.console.historyPos];
                        this.write(this.console.line + this.getCaret());
                    }
                    break;

                case "ArrowDown":
                    if (this.console.historyPos < this.console.history.length - 1) {
                        this.clearLine();
                        this.console.historyPos += 1;
                        this.console.line = this.console.history[this.console.historyPos];
                        this.write(this.console.line + this.getCaret());
                    }
                    break;

                default:
                    this.clearCaret();
                    this.write(key + this.getCaret());
                    this.console.line += key;
            }
        },

        consoleClick: function($event) {
            this.clearCaret();
            this.setCaretPos($event.target, this.console.content.length + 1);
            this.console.content += this.getCaret();
            this.scrollToBottom();
        },

        newLine: function() {
            this.write(this.getPrompt());
            this.console.lastPrompt = this.console.content.length;
            this.write(this.getCaret());
            setTimeout(() => {
                this.scrollToBottom();
            }, 100);
        },

        scrollToBottom: function() {
            this.console.area.scrollTop = this.console.area.scrollHeight;
        },

        sendLineToHistory: function(line) {
            this.console.history.push(line.trim());
        },

        consoleCommand: function(line) {
            var response = "";
            var mood = "normal";
            var words = line.split(" ");
            var command = (words[0] || "").toLowerCase().replace(/\?/g, "");

            this.console.line = "";

            if (line !== "") {
                switch (command) {
                    case "clear":
                    case "cls":
                        this.console.content = "";
                        break;

                    case "collapse":
                    case "comprimi":
                        this.toggleSections(true);
                        mood = "ok";
                        response = "All sections collapsed.";
                        break;

                    case "expand":
                    case "espandi":
                        this.toggleSections(false);
                        mood = "ok";
                        response = "All sections expanded.";
                        break;

                    case "maximize":
                        this.maximizeConsole();
                        break;

                    case "restore":
                        this.restoreConsole();
                        break;

                    case "prompt":
                        if (typeof words[1] === "undefined") {
                            response = "prompt [text] or prompt empty";
                            mood = "error";
                        } else if (words[1] === "empty" || words[1] === "") {
                            this.console.prompt = "";
                            mood = "ok";
                            response = "Prompt cleared.";
                        } else {
                            this.console.prompt = words[1] + " ";
                            mood = "ok";
                            response = "Prompt set to '" + words[1] + "'.";
                        }
                        break;

                    case "help":
                    case "man":
                    case "aiuto":
                        response = this.getManual(words[1] || "help");
                        break;

                    case "projects":
                        response = this.renderLinkList(this.sections.projects.content.code, "Projects")
                            + "<br><br>" + this.renderLinkList(this.sections.projects.content.archive, "Archive");
                        break;

                    case "links":
                        response = this.renderLinkList(this.sections.informations.content.links, "Links");
                        break;

                    case "about":
                        response = this.sections.about.content.text;
                        break;

                    case "play":
                        this.maximizeConsole();
                        response = "Adventure commands are in Italian. Try: guarda, esamina, inventario, nord, sud, prendi mela, save, load. Type restore to shrink the console.";
                        break;

                    case "open":
                    case "show":
                        var target = words.slice(1).join(" ").trim();
                        var link = this.findPublicLink(target);

                        if (!target) {
                            mood = "error";
                            response = manuals.open;
                        } else if (!link) {
                            mood = "error";
                            response = "No public link matches '" + target + "'.";
                        } else {
                            mood = "ok";
                            response = "Opening " + link.label + ".";
                            window.open(link.path);
                        }
                        break;

                    default:
                        if (!(this.gameOn && GAME.command(line))) {
                            mood = "error";
                            response = "?SYNTAX ERROR<br>READY.";
                        } else {
                            this.newLine();
                            this.backup();
                            return;
                        }
                }
            }

            if (response !== "") {
                this.write(response, true, mood);
            }

            this.newLine();
            this.backup();
        },

        toggleSections: function(collapsed) {
            for (var section in this.sections) {
                if (section === "console") continue;
                this.sections[section].state.collapsed = collapsed;
            }
        },

        renderLinkList: function(items, heading) {
            var response = heading + ":<br>";
            for (var i = 0; i < items.length; i++) {
                response += items[i].label;
                if (items[i].year) response += " (" + items[i].year + ")";
                if (items[i].status) response += " [" + items[i].status + "]";
                if (items[i].desc) response += " - " + items[i].desc;
                if (i < items.length - 1) response += "<br>";
            }
            return response;
        },

        projectLinks: function() {
            var code = this.sections.projects.content.code || [];
            var demo = this.sections.projects.content.demo || [];
            return code.concat(demo);
        },

        findPublicLink: function(term) {
            if (!term) return null;

            var allLinks = []
                .concat(this.sections.informations.content.links)
                .concat(this.sections.projects.content.code)
                .concat(this.sections.projects.content.archive);
                // .concat(this.sections.projects.content.demo);

            term = term.toLowerCase();

            for (var i = 0; i < allLinks.length; i++) {
                var label = (allLinks[i].label || "").toLowerCase();
                var desc = (allLinks[i].desc || "").toLowerCase();
                if (label.indexOf(term) !== -1 || desc.indexOf(term) !== -1) {
                    return allLinks[i];
                }
            }

            return null;
        },

        getManual: function(command) {
            return manuals[command] || manuals.help;
        },

        clearCaret: function() {
            this.console.content = this.console.content.replace(new RegExp(this.getCaret(), "g"), "");
        },

        clearLine: function() {
            this.console.content = this.console.content.substring(0, this.console.lastPrompt);
        },

        clearLineAndPrompt: function() {
            this.console.content = this.console.content.substring(0, this.console.lastPrompt - this.console.prompt.length - 3);
        },

        write: function(text, cr, color) {
            if (text) {
                this.console.content += (color ? '<span class="console-' + color + '">' : "") + text + (color ? "</span>" : "");
            }
            if (cr) this.console.content += "<br>";
        },

        getPrompt: function() {
            if (!this.console.prompt) return "";
            return '<span class="prompt">' + this.console.prompt + "</span>";
        },

        getCaret: function() {
            return '<span class="caret blink">' + this.console.caret + "</span>";
        },

        setCaretPos: function(el, pos) {
            if (el !== null) {
                if (el.createTextRange) {
                    var range = el.createTextRange();
                    range.move("character", pos);
                    range.select();
                    return true;
                } else if (el.selectionStart || el.selectionStart === 0) {
                    el.focus();
                    el.setSelectionRange(pos, pos);
                    return true;
                } else {
                    el.focus();
                    return false;
                }
            }
        }
    }
});
